import { useSuspenseQuery } from "@tanstack/react-query";
import { NotebookPen, Plus } from "lucide-react";
import { useState } from "react";
import { Button } from "@/shared/components/ui/button";
import { useCreateSplit } from "./api/splits.mutations";
import { splitsQueryOptions } from "./api/splits.queries";
import { useSplitsRealtime } from "./api/splits.realtime";
import { ConnectionBanner } from "./components/ConnectionBanner";
import { SplitsBoard } from "./components/SplitsBoard";

const NOTES_PREF_KEY = "splits:show-notes";

// Personal, per-browser view preference — whether the note column is shown. Not synced.
function useShowNotes() {
  const [show, setShow] = useState(
    () => localStorage.getItem(NOTES_PREF_KEY) === "1",
  );
  const toggle = () =>
    setShow((prev) => {
      const next = !prev;
      localStorage.setItem(NOTES_PREF_KEY, next ? "1" : "0");
      return next;
    });
  return [show, toggle] as const;
}

export function SplitsPage() {
  const { data } = useSuspenseQuery(splitsQueryOptions);
  const createSplit = useCreateSplit();
  const realtime = useSplitsRealtime();
  const [showNotes, toggleNotes] = useShowNotes();

  return (
    <div>
      <ConnectionBanner status={realtime.status} />
      <div className="relative">
        <div className="absolute right-0 top-0 z-10 flex gap-2">
          <Button
            variant={showNotes ? "secondary" : "outline"}
            onClick={toggleNotes}
            aria-pressed={showNotes}
          >
            <NotebookPen />
            {showNotes ? "Dölj anteckningar" : "Visa anteckningar"}
          </Button>
          <Button
            loading={createSplit.isPending}
            onClick={() =>
              createSplit.mutate(`Split ${data.splits.length + 1}`)
            }
          >
            <Plus />
            Lägg till split
          </Button>
        </div>
        <SplitsBoard data={data} realtime={realtime} showNotes={showNotes} />
      </div>
    </div>
  );
}
